import {
  StripeExpressCheckoutElementOptions,
  StripePaymentRequestButtonElementOptions,
} from '@stripe/stripe-js'

import { CheckoutFlowVersion } from '@/enums/payments'
import { PaymentScreenVersion } from '@/enums/paymentScreenVersion'
import { StripeWalletButtonTheme } from '@/enums/stripe'

const isDefaultVersion = window.config.PAYMENT_SCREEN_VERSION === PaymentScreenVersion.default

const baseStripePaymentRequestButton: StripePaymentRequestButtonElementOptions['style'] = {
  paymentRequestButton: {
    height: '55px',
    type: isDefaultVersion ? 'default' : 'buy',
  },
}

const stripePaymentRequestButton: Record<
  StripeWalletButtonTheme,
  StripePaymentRequestButtonElementOptions['style']
> = {
  [StripeWalletButtonTheme.dark]: {
    paymentRequestButton: {
      ...baseStripePaymentRequestButton.paymentRequestButton,
      theme: StripeWalletButtonTheme.dark,
    },
  },
  [StripeWalletButtonTheme.light]: {
    paymentRequestButton: {
      ...baseStripePaymentRequestButton.paymentRequestButton,
      theme: StripeWalletButtonTheme.light,
    },
  },
}

const baseStripeExpressCheckoutButton: StripeExpressCheckoutElementOptions = {
  buttonHeight: 55,
  paymentMethods: {
    link: 'never',
    paypal: 'never',
    amazonPay: 'never',
  },
  buttonType: {
    googlePay: 'plain',
  },
}

const stripeExpressCheckoutButton: Record<
  StripeWalletButtonTheme,
  StripeExpressCheckoutElementOptions
> = {
  [StripeWalletButtonTheme.dark]: {
    ...baseStripeExpressCheckoutButton,
    buttonTheme: {
      applePay: 'black',
      googlePay: 'black',
    },
  },
  [StripeWalletButtonTheme.light]: {
    ...baseStripeExpressCheckoutButton,
    buttonTheme: {
      applePay: 'white',
      googlePay: 'white',
    },
  },
}

export type TGetStripeWalletButtonStyleFn = ((
  theme: StripeWalletButtonTheme,
  version: CheckoutFlowVersion.V1
) => StripePaymentRequestButtonElementOptions['style']) &
  ((
    theme: StripeWalletButtonTheme,
    version: CheckoutFlowVersion.V2
  ) => StripeExpressCheckoutElementOptions)

export function getStripeWalletButtonStyles(
  theme: StripeWalletButtonTheme,
  version: CheckoutFlowVersion.V1
): StripePaymentRequestButtonElementOptions['style']
export function getStripeWalletButtonStyles(
  theme: StripeWalletButtonTheme,
  version: CheckoutFlowVersion.V2
): StripeExpressCheckoutElementOptions
export function getStripeWalletButtonStyles(
  theme: StripeWalletButtonTheme,
  version: CheckoutFlowVersion
): StripePaymentRequestButtonElementOptions['style'] | StripeExpressCheckoutElementOptions {
  if (version === CheckoutFlowVersion.V1) {
    return stripePaymentRequestButton[theme]
  } else if (version == CheckoutFlowVersion.V2) {
    return stripeExpressCheckoutButton[theme]
  }
}
